<template>
  <div bottom-tag-content>
    <slot/>
    <div card-tags-abs>
      <div card-tags-rel>
        <div card-tags>
          <div class="display">
            <template v-for="tag in tags">{{tag}}<s :key="tag"/></template>
          </div>
          <div class="list">
            <a ref="tags" v-for="tag in tags" :key="tag" @click="$emit('click', tag)"><s>{{tag}}</s></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BottomTagContent',
  props: ['tags'],
  watch: {
    tags: 'update',
  },
  methods: {
  },
  mounted() {
  },
};
</script>

<style lang="less">
@import "~@/less/proj";
[bottom-tag-content] { .-box; .rel; .p(20,20,50); .bgc(#fff);
  [card-tags-abs] { .abs; .lb(0,15); .wf; .p(0,20); .-box;
    [card-tags-rel] { .rel;
      [card-tags] { .abs; .lb; .wf; .fs(12); .ls(-0.5); color: #757575; .nowrap; overflow: hidden; .-box; .pb(3);
        .display { .ellipsis;
          s { .ib; .w(10); }
        }
        .list { .abs; .lt;
          a { .ib; .rel; .gap-h(10);
            s { opacity: 0; }
            &:after { .cnt; .abs; .wh(100%, 1px); .bgc(#9e9e9e); .lb(0, -3); }
          }
        }
      }
    }
  }
}
</style>
